const stringInputValidation = (key, label, validation) => {
    const max = validation && validation.max || 45;
    const min = validation && validation.min || 2;
    return [
        {required: true, message: `Please input ${label}!`},
        {max, message: `${label} cannot be longer than ${max} characters`},
        {min, message: `${label} must be at least ${min} characters`}
    ];
};

export {stringInputValidation}